import { X } from 'lucide-react';
import { useState } from 'react';
import type { Ingredient } from '@/shared/types';

interface IngredientInputProps {
  ingredients: Ingredient[];
  onChange: (ingredients: Ingredient[]) => void;
}

export function IngredientInput({ ingredients, onChange }: IngredientInputProps): JSX.Element {
  const [value, setValue] = useState('');

  const addIngredient = (): void => {
    const trimmed = value.trim();
    if (trimmed.length === 0) return;

    onChange([...ingredients, { name: trimmed }]);
    setValue('');
  };

  const removeIngredient = (index: number): void => {
    onChange(ingredients.filter((_, i) => i !== index));
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      addIngredient();
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-slate-700 dark:text-slate-300">Ингредиенты (необязательно)</label>

      <div className="flex flex-wrap gap-2">
        {ingredients.map((ingredient, index) => (
          <span
            key={`${ingredient.name}-${index}`}
            className="inline-flex items-center gap-1 rounded-full bg-purple-500/20 px-3 py-1 text-sm text-purple-800 dark:text-purple-200"
          >
            {ingredient.name}
            <button
              type="button"
              onClick={() => removeIngredient(index)}
              className="rounded-full p-0.5 hover:bg-purple-500/30"
            >
              <X className="h-3 w-3" />
            </button>
          </span>
        ))}
      </div>

      <input
        type="text"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Введите ингредиент и нажмите Enter"
        className="w-full rounded-xl border border-black/10 bg-white/50 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-pink-500/50 focus:outline-none focus:ring-2 focus:ring-pink-500/20 dark:border-white/10 dark:bg-slate-900/50 dark:text-slate-100 dark:placeholder:text-slate-500"
      />
    </div>
  );
}
